/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { ContainerIcon as icon } from '../../components/Icons';
import styles from './inline-styles';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes, supports } = metadata;

const settings = {
	title: __( 'Container' ),
	description: __( 'Combine blocks into a group.' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'container' ),
		__( 'section' ),
		__( 'group' ),
		__( 'wrapper' ),
		__( 'row' ),
	],
	example: {
		attributes: {
		},
	},
	attributes,
	edit,
	save,
	supports,
	gutenify: {
		customStylesCallback( props ) {
			return styles( props );
		},
	},
};

export { name, category, settings };
